import {Question} from '../interfaces/question.interface';

export const trackByTag = (...args) => args[1];

export const trackByQuestion = (...args) => (args[1] as Question).id;
